// extracted by mini-css-extract-plugin
module.exports = {"container":"_9400a595a7--container--zJnJF","title":"_9400a595a7--title--R7coy","link":"_9400a595a7--link--APgqE","title-icon":"_9400a595a7--title-icon--mhogC"};